import { AppData, Registry } from "@lightningjs/sdk";
import { AppSetup } from "./app-setup";
import { Helper } from "./helper";
import { Logger } from "./logger";
import { fetchData, getBookmarkingData, getPromoContentUrl } from "./models/data-service";
import { parseVideos } from "./parser";
import { ItemNode } from "./components/grid/ItemNode";
import GridViewModel from "./components/grid/grid-view-model";
import RowList from "./components/grid/row-model";
import { GRIDTYPE, PLATFORM, REQUEST_STATUS } from "./enum";
import { Router } from "@lightningjs/sdk";
import { AppApiConfig } from "./app-api-config";

export class Deeplink {
    playFirstDeeplinkVideo = false;
    firstPlaylistVideo = null;
    nodeId = null;
    firstPlayIndex = 0;
    nodeIdFound = false;
    deeplinkList = [];
    maxVideosLimit = 10;
    secondLastPageFetched = false;
    playListIndx = 0;
    listoflistRowIndex = 0;
    nodeToPlayFound = false;
    seasonId = null;
    episodeNo = null;
    loadingListoflistPage = false;
    consumer:any;
    notFoundMsgNoSeconds = 5000
    constructor() {
    }

    getDeeplinkingParams(contentChangeUrl:any,consumer:any) {
        const { appConfig, platform, appState } = AppData as AppSetup;
        this.consumer=Router.getActivePage()
        let playId;
        let searchKeys;
        let type;
        let showsKeys;
        let seasonId;
        let episodeNumber;
        let src = 'hs-search';

        if (Helper.isEmpty(contentChangeUrl)) {
            appState.deeplinks.playId = '';
            appState.playlistPlayMode = false;
            return;
        }

        playId = Helper.urlParam('playId', contentChangeUrl);
        searchKeys = Helper.urlParam('searchKeys', contentChangeUrl);
        type = Helper.urlParam('type', contentChangeUrl);
        showsKeys = Helper.urlParam('showsKeys', contentChangeUrl);
        seasonId = Helper.urlParam('seasonId', contentChangeUrl);
        episodeNumber = Helper.urlParam('episodeNumber', contentChangeUrl);
        src = Helper.urlParam('src', contentChangeUrl);
        appState.deeplinks.isInvalidPattern = false;



        if (!Helper.isEmpty(playId)) {
            if(src && src !== '') {
                appState.deeplinks.sourceType = src
            } else {
                appState.deeplinks.sourceType = (src == 'promo' ? 'hs-d' : 'external-control');
            }
            appState.deeplinks.playId = playId;
            appState.playlistPlayMode = true;
            appState.deeplinks.type = 'shows';

            if (playId.indexOf('dy-') == 0) {
                var playObjArr = playId.split('-');
                if (playObjArr.length < 3) {
                    appState.deeplinks.isInvalidPattern = true;
                } else if (playObjArr[1] == "" || playObjArr[2] == "") {
                    appState.deeplinks.isInvalidPattern = true;
                }
                appState.deeplinks.type = 'movies';
            } else if(playId.indexOf('ro:new-qid') == 0) {
                appState.deeplinks.type = 'movies';
            } else if(playId.indexOf('ro:listoflist') == 0){
                var playIdSplitArr = playId.split('::');
                var showId = playIdSplitArr[0].split(':')[2];//playId.split(':')[2];
                Logger.printLog('info', 'showId ',showId);
                var isValid = false;
                if(showId){
                    isValid = true;
                }
                if(!isValid){
                    appState.deeplinks.isInvalidPattern = true;
                }
            }
        } else if (!Helper.isEmpty(type)) {
            appState.deeplinks.sourceType = 'hs-search';
            appState.deeplinks.type = type;
            appState.deeplinks.searchKeys = searchKeys;
            appState.deeplinks.showsKeys = showsKeys;
            // appState.deeplinks.seasonId = seasonId;
            // appState.deeplinks.episodeNumber = episodeNumber;

            if (type == 'movies') {
                if (showsKeys == '' || searchKeys == '') {
                    appState.deeplinks.isInvalidPattern = true;
                }
                playId = 'dy-' + searchKeys + '-' + showsKeys;
            } else if (type == 'show') {
                //direct link to shows id
                if (showsKeys == '' || searchKeys == '') {
                    appState.deeplinks.isInvalidPattern = true;
                }
                if (searchKeys == showsKeys) {
                    //shows and start s1e1
                    playId = 'ro:listoflist:' + showsKeys;
                } else {
                    //e1 of the specific season of the shows.
                    playId = 'ro:listoflist:' + showsKeys + '::ro:new-qid:' + searchKeys;
                }
            } else if (type == 'episode') {
                // VegaOS (FireTV) - episode deeplinks arrive without a season id
                if (appConfig?.platform_id == PLATFORM.FIRETV) {
                    if (seasonId == '' && showsKeys != '') {
                        appState.deeplinks.isInvalidPattern = false;
                        playId = 'ro:listoflist:' + showsKeys + '::dy-' + searchKeys + '-' + showsKeys;
                        appState.deeplinks.playId = playId;
                        appState.playlistPlayMode = true;

                    }
                    return
                }
                if (showsKeys == '' || searchKeys == '' || seasonId == '') {
                    appState.deeplinks.isInvalidPattern = true;
                }
                if (episodeNumber !== undefined) {
                    //new pattern
                    playId = 'ro:listoflist:' + showsKeys + '::ro:new-qid:' + seasonId + '::dy-' + searchKeys + '-' + showsKeys + '-' + episodeNumber;
                } else {
                    //old pattern
                    playId = 'ro:listoflist:' + showsKeys + '::dy-' + searchKeys + '-' + showsKeys;
                }

            }
            appState.deeplinks.playId = playId;
            appState.playlistPlayMode = true;
        } else {
            appState.deeplinks.playId = '';
            appState.playlistPlayMode = false;
        }
    }

    handleFireTvEpisodeDeeplink(playId) {
        let playIdSplitArr = playId.split('::');
        debugger;

    }

    handleError = () => {
        const { appConfig, platform, appState } = AppData as AppSetup;
        Logger.processUserAction('Deeplink_NodeNotFoundMessageShown_' + appState.deeplinks.playId);
        appState.deeplinks.isInvalidPattern = true;
        appState.playlistPlayMode = false;
        appState.deeplinks.playId = '';
        this.deeplinkList = null;
        // this.consumer.showHideMessage(true);
        // Registry.setTimeout(() => {
        //     this.consumer.showHideMessage(false);
        //     this.loadPageAfterDeeplink();
        // }, this.notFoundMsgNoSeconds)
        this.loadPageAfterDeeplink(true);
    }

    loadPlaylistAndPlay = async () => {
        Logger.printLog('info', 'loadPlaylistAndPlay', '');
        const { appConfig, platform, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        appState.playlistPlayMode = true;
        // New Format for Episodes - "ro:listoflist:12600::new-qid:23456::dy-10289451-1447600-8"
        if (appState.deeplinks.playId.indexOf('%') !== -1) { //means URL encoded values coming up
            appState.deeplinks.playId = decodeURIComponent(appState.deeplinks.playId);
        }
        // get node id array
        let playIdSplitArr = appState.deeplinks.playId.split('::');
        if (appState.deeplinks.playId.indexOf('ro:listoflist') !== -1) {
            let showId = appState.deeplinks.playId.split(':')[2];
            playIdSplitArr = appState.deeplinks.playId.split('::');
            if (playIdSplitArr[1] !== undefined) {
                let seasonArr = playIdSplitArr[1].split(':');
                if (playIdSplitArr[1].indexOf('ro:new-qid:') !== -1) {
                    this.seasonId = seasonArr[seasonArr.length - 1];
                } else if (playIdSplitArr[1].indexOf('new-qid:') !== -1) {
                    this.seasonId = seasonArr[seasonArr.length - 1];
                }
            }
            if (playIdSplitArr[2] !== undefined) {
                //dy-node is present.
                let dyArr = playIdSplitArr[2].split('-');
                this.nodeId = dyArr[1];
                if (dyArr[3] !== undefined) {
                    if (parseInt(dyArr[3]) !== 'NaN') {
                        this.episodeNo = dyArr[3];
                        if(this.episodeNo.indexOf('@')>-1){
                            this.episodeNo = this.episodeNo.split("@")[0];
                        }
                    }
                }
            }
            // VegaOS (FireTV) - resolve the episode node id from the play id
            if (appConfig?.platform_id == PLATFORM.FIRETV) {
                playIdSplitArr = appState.deeplinks.playId.split('::')
                if (appState.deeplinks.playId.indexOf('::dy-')) {
                    //had episode. hence set this seasonId to -1 and set episodeNo to episode node idf.
                    this.seasonId = '-1'
                    this.nodeId = playIdSplitArr[1].split('-')[1]
                }
            }
            appState.deeplinks.type = 'listoflist';
            if (this.episodeNo !== null) {
                Logger.processUserAction('launchingAppViaSeasonDeepLink_NewFormat');
            } else {
                Logger.processUserAction('launchingAppViaSeasonDeepLink');
            }
            Logger.printLog('info', `showId > ${showId}  : seasonId > ${this.seasonId}  : episodeNo > ${this.episodeNo}`,'');
            Logger.logSourceInfo();
            /** [Fix for XFIN-1044 - Solr Error: Due to wrong key value in comcast] - START */
            let playId = appState.deeplinks.playId;
            if(playId && playId.indexOf('@')>-1){
                playId = playId.split("@")[0];
            }
            let promoUrl = getPromoContentUrl(playId);
            /** [Fix for XFIN-1044 - Solr Error: Due to wrong key value in comcast] - END */
            const itemNode: ItemNode = new ItemNode()
            itemNode.type = 'deeplink'
            itemNode.url = promoUrl;
            itemNode.id = showId;

            let gridViewModel = new GridViewModel(itemNode, true, 'deeplink');
            gridViewModel.type = GRIDTYPE.DEEPLINK;
            await gridViewModel._init();
            //gridViewModel.once('loaded',()=>{
            if(!gridViewModel.gridModel.categoryList){
                this.handleError();
                return
            }
            if(gridViewModel.gridModel.categoryList.length==0){
                this.handleError();
                return
            }
            gridViewModel.createGridListUI();
            app.deeplinkGrid = gridViewModel;
            app.navigation.push(gridViewModel);
            let focusRowIndex = 0;
            let episodeIndex = 0;
            let isEpisodeFound = false;
            let isNodeFound = false;
            let seasonRow!: RowList;

            // VegaOS (FireTV) - search every season row for the node id
            if (appConfig?.platform_id == PLATFORM.FIRETV) {
                let nodeIndex = 0;
                if (this.nodeId) {
                    let lastPageNo = 0;
                    for (let r = 0; r < gridViewModel.gridModel.categoryList.length; r++) {
                        focusRowIndex = r
                        gridViewModel.checkAndLoadMoreRows(focusRowIndex);
                        seasonRow = gridViewModel.getRowAt(focusRowIndex)!;
                        await seasonRow.fetchMoreVideos(0);
                        for (let i = 0; i < seasonRow.videosCount; i++) {
                            if (!seasonRow.videos[i]) {
                                const nextPageToFetch = Math.floor(i / seasonRow.limit)
                                lastPageNo = nextPageToFetch
                                await seasonRow.fetchMoreVideos(nextPageToFetch)
                            }
                            if (this.nodeId == seasonRow.videos[i]?.node_id) {
                                isNodeFound = true;
                                this.seasonId = seasonRow.id
                                nodeIndex = i;
                                break;
                            }
                        }
                        if (isNodeFound) {
                            break;
                        }    
                        lastPageNo++;
                        if (lastPageNo <= seasonRow.totalPages - 1) {
                            await seasonRow.fetchMoreVideos(lastPageNo)
                        }                    
                    }
                    if (isNodeFound) {
                        gridViewModel.changeFocus({
                            focusRow: focusRowIndex,
                            foucsItem: nodeIndex,
                        })
                    } else {
                        gridViewModel.changeFocus({
                            focusRow: focusRowIndex,
                            foucsItem: 0,
                        })
                    }
                }
            } else {
                if(this.seasonId){
                    focusRowIndex = gridViewModel.gridModel.categoryList.findIndex(p => p.rowList.id == this.seasonId);
                }
                if(focusRowIndex==-1){
                    this.handleError();
                    return
                }
                gridViewModel.checkAndLoadMoreRows(focusRowIndex);
                seasonRow = gridViewModel.getRowAt(focusRowIndex)!;
                await seasonRow.fetchMoreVideos(0);
                if(this.episodeNo){
                    let lastPageNo = 0
                    for(let i=0;i<seasonRow.videosCount;i++){
                        if(!seasonRow.videos[i]){
                            const nextPageToFetch = Math.floor(i / seasonRow.limit)
                            lastPageNo = nextPageToFetch
                            await seasonRow.fetchMoreVideos(nextPageToFetch)
                        }
                        if(Number(this.episodeNo) == seasonRow.videos[i]?.episode){
                            episodeIndex = i;
                            isEpisodeFound = true
                            break;
                        }
                    }
                    lastPageNo++;
                    if(lastPageNo<=seasonRow.totalPages-1){
                        await seasonRow.fetchMoreVideos(lastPageNo)
                    }
                } else {
                    if(!this.nodeId){
                        isEpisodeFound=true;
                    }
                }
                if(isEpisodeFound){
                    gridViewModel.changeFocus({
                        focusRow: focusRowIndex,
                        foucsItem: episodeIndex,
                    })
                } else {
                    let nodeIndex = 0;
                    if(this.nodeId){
                        let lastPageNo = 0;
                        for(let i=0;i<seasonRow.videosCount;i++){
                            if(!seasonRow.videos[i]){
                                const nextPageToFetch = Math.floor(i / seasonRow.limit)
                                lastPageNo = nextPageToFetch
                                await seasonRow.fetchMoreVideos(nextPageToFetch)
                            }
                            if(this.nodeId == seasonRow.videos[i]?.node_id){
                                isNodeFound=true;
                                nodeIndex = i;
                                break;
                            }
                        }
                        lastPageNo++;
                        if(lastPageNo<=seasonRow.totalPages-1){
                            await seasonRow.fetchMoreVideos(lastPageNo)
                        }
                    }
                    if(isNodeFound){
                        gridViewModel.changeFocus({
                            focusRow: focusRowIndex,
                            foucsItem: nodeIndex,
                        })
                        //app?.initAdHandler();
                        //const vodInfo: ItemNode = gridViewModel.getFocusedItem();
                        //Router.navigate('video-screen/'+vodInfo.node_id+'_resume', false)
                        //this._handleBookmarking(vodInfo)
                        //Router.getActivePage()._handleBookmarking(gridViewModel.channelInfo, true)
                    } else {
                        gridViewModel.changeFocus({
                            focusRow: focusRowIndex,
                            foucsItem: 0,
                        })
                    }
                }
            }
            if(isNodeFound || isEpisodeFound){
                //app?.initAdHandler();
                let vodInfo: ItemNode = gridViewModel.getFocusedItem();
                if(!this.seasonId && !this.episodeNo) {
                    // as we dont know the season no for bookmarking. we call the bookmarking api to get the bookmarked vodInfo
                    // and then set the season id to the channelInfo.
                    const bdataResults  = await fetchData(getBookmarkingData(gridViewModel.channelInfo))
                    const bdata = parseVideos(bdataResults.data)
                    if(bdata.length>1) {
                        gridViewModel.channelInfo.season = bdata[1]?.season
                    }
                    this._handleBookmarking(gridViewModel.channelInfo)
                } else {
                    if(app?.blockingManager.isItemBlocked(vodInfo)) {
                        vodInfo = await app.getNextItem();
                    }
                    this._handleVideoResume(vodInfo)
                }
            } else {
                this.handleError();
            }
        } else {
            const isQid = appState.deeplinks.playId.indexOf('ro:new-qid') == 0 ? true : false;
            if (typeof playIdSplitArr[1] !== 'undefined') {
                this.nodeId = playIdSplitArr[1];
            }
            let moviePlayIdSplitArr = appState.deeplinks.playId.split('-')
            let movieNodeId = moviePlayIdSplitArr[1];
            appState.deeplinks.type = 'movies';
            /** [Fix for XFIN-1044 - Solr Error: Due to wrong key value in comcast] - START */
            let playId = appState.deeplinks.playId;
            if(playId && playId.indexOf('@')>-1){
                playId = playId.split("@")[0];
            }
            let promoUrl = getPromoContentUrl(playId);
            /** [Fix for XFIN-1044 - Solr Error: Due to wrong key value in comcast] - END */
            Logger.processUserAction('launchingAppViaMovieDeepLink');
            Logger.logSourceInfo()
            const itemNode: ItemNode = new ItemNode()
            itemNode.type = 'deeplink'
            let gridViewModel = new GridViewModel(itemNode, false, 'deeplink')
            const rowStyle: { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } = Helper.getRowStyle()
            const rowData = {
                description: 'deeplink',
                dynamic_deeplink: '',
                feed_type: 'video',
                name: 'Deeplink',
                row_height: rowStyle.row_height,
                row_item_height: rowStyle.row_item_height,
                row_item_width: rowStyle.row_item_width,
                rowstyle: rowStyle.rowstyle,
                row_sub_type: '',
                row_type: 'mixed-content-row',
                url: promoUrl
            }
            const rowList = new RowList(rowData)
            gridViewModel.add(rowList)
            gridViewModel.type = GRIDTYPE.DEEPLINK
            gridViewModel.fetchInitialRows().then(async ()=>{
                gridViewModel.createGridListUI();
                const rowList =gridViewModel.getRowAt(0)
                if(rowList?.initFetcingStatus == REQUEST_STATUS.OK){
                    app.deeplinkGrid = gridViewModel;
                    app.navigation.push(gridViewModel);
                    let vodInfo: ItemNode = gridViewModel.getFocusedItem();
                    if(isQid) {
                        if(app?.blockingManager.isItemBlocked(vodInfo)) {
                            vodInfo = await app.getNextItem();
                        }
                        this._handleVideoResume(vodInfo)
                    } else if(movieNodeId==vodInfo.node_id){
                        //app?.initAdHandler();
                        //Router.navigate('video-screen/'+vodInfo.node_id+'_resume', false)
                        if(app?.blockingManager.isItemBlocked(vodInfo)) {
                            vodInfo = await app.getNextItem();
                        }
                        this._handleVideoResume(vodInfo)
                    } else {
                        this.handleError();
                    }
                } else {
                    this.handleError();
                }
            })
        }
    }

    loadPageAfterDeeplink=(isError)=>{
        const { appState } = AppData as AppSetup
        const appApiConfig: AppApiConfig | undefined = appState?.getAppApiConfig()
        //Fix for XFIN-1038 START//
        /*if (appApiConfig?.appConfig?.displaySelectScreen) {
            Router.navigate('select-screen', false)            
        } else {
            Router.navigate('main-grid-screen/'+0, false)
        }*/
        if (isError) {
            appState.showDeeplinkSorryMsgOnGrid = true;
        }
       Router.navigate('main-grid-screen/'+0, false)
       //Fix for XFIN-1038 END//
    }

    _handleBookmarking(vodInfo) {
        Router.getActivePage().widgets.bookmark.$setbdata(vodInfo, true)
        Router.focusWidget('Bookmark')
    }

    _handleVideoResume(vodInfo) {
        const { appConfig, appState, platform } = AppData as AppSetup;

        // VegaOS (FireTV) - no resume screen, continue watching handles it
        if (platform?.skipBookmarkOnDeeplink) {
            Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false);
            return;
        }

        const appApiConfig = appState?.getAppApiConfig()
        let resumeTime = null
        if (appConfig?.useLocalStorage == true) {
            resumeTime = localStorage.getItem(vodInfo.node_id)!;
        } else {
            resumeTime = Helper.getCookie(vodInfo.node_id);
        }

        if (resumeTime !== "" && resumeTime !== null && resumeTime !== 0 && resumeTime !== '0' && (appApiConfig?.appConfig?.resumeVidMinDuration && vodInfo.runtime > appApiConfig?.appConfig?.resumeVidMinDuration)) {
            Router.getActivePage().widgets.bookmark.$setbdata(vodInfo, true)
            Router.focusWidget('Bookmark')
        } else {
            Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false)
        }
    }
}
